import { useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { ApiError } from '../api/client';
import { useAccountApi, useAppData } from '../app/AppContext';

export function useDebtCommand() {
  const { apiMutation } = useAccountApi();
  const { workspace } = useAppData();
  const [workspaceId] = useState(workspace?.id);
  const currentWorkspace = useRef(workspace?.id);
  useEffect(() => {
    currentWorkspace.current = workspace?.id;
    return () => { currentWorkspace.current = undefined; };
  }, [workspace?.id]);
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const queryClient = useQueryClient();
  const changed = workspaceId !== workspace?.id;
  const invalidate = () => queryClient.invalidateQueries({
    predicate: query => query.queryKey.includes(workspaceId) && ['finance', 'dashboard', 'history', 'report'].includes(String(query.queryKey[0])),
  });
  const run = async (path: string, options: Parameters<typeof apiMutation>[1], onSuccess: () => void) => {
    if (pending.current) return;
    if (currentWorkspace.current !== workspaceId || workspaceId === undefined) {
      setError('Пространство изменилось. Откройте форму заново.'); return;
    }
    pending.current = true; setBusy(true); setError('');
    try {
      await apiMutation(`/workspaces/${workspaceId}${path}`, options);
      await invalidate();
      if (currentWorkspace.current === workspaceId) onSuccess();
    } catch (caught) {
      if (caught instanceof ApiError && caught.code === 'VERSION_CONFLICT') {
        await invalidate();
        setError('Данные обновлены: остаток изменён другим участником. Проверьте сумму и сохраните ещё раз. Введённые поля сохранены.');
      } else setError(caught instanceof Error ? caught.message : 'Не удалось сохранить');
    } finally { pending.current = false; setBusy(false); }
  };
  return { workspaceId, changed, busy, error, setError, run };
}
